import { Component, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

import { CUSTOM_PRICING_MAP, FREE_PRICING_MAP } from 'app/constants/pricing.data';
import { OfferProductPosition } from 'graphql/models/extended';
import { LineSubtypePropVal } from 'models/position.model';
import { AddArticleToOfferComponent } from 'shared/forms/article/add-article-to-offer/add-article-to-offer.component';
import { OfferPositionService } from 'shared/services/offer-position.service';
import { PricingService } from 'shared/services/pricing.service';
import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-add-article-to-offer-modal',
  templateUrl: './add-article-to-offer-modal.component.html',
  styleUrls: ['./add-article-to-offer-modal.component.scss']
})
export class AddArticleToOfferModalComponent {
  @ViewChild(AddArticleToOfferComponent) addArticleToOfferComponent!: AddArticleToOfferComponent;

  get form(): UntypedFormGroup {
    return this.addArticleToOfferComponent.form;
  }

  constructor(
    private offerPositionService: OfferPositionService,
    private pricingService: PricingService,
    private storeService: StoreService
  ) {
  }

  onSubmit(): Observable<any> {
    const productId = String(this.addArticleToOfferComponent.selectedArticle.id);
    const offer = this.addArticleToOfferComponent.offer;
    const positionId = this.addArticleToOfferComponent.position.id;
    const isDealer = this.addArticleToOfferComponent.isDealer;
    const quantity = Number(this.form.controls.quantity.value || 1);

    return this.offerPositionService.updateAllPositionFields(
      offer,
      positionId,
      quantity,
      this.form.controls.description.value,
      this.form.controls.number.value,
      this.form.controls.text.value,
      (isDealer ? productId : ''),
      (isDealer ? LineSubtypePropVal.MY_ARTICLE : LineSubtypePropVal.FREE_ARTICLE),
      this.addArticleToOfferComponent.selectedArticle.name,
      this.addArticleToOfferComponent.selectedArticle.description,
      (!isDealer ? JSON.stringify(this.addArticleToOfferComponent.selectedArticle) : '')
    ).pipe(
      concatMap(() => {
        const listPriceStepId = (isDealer ? CUSTOM_PRICING_MAP.listPrice : FREE_PRICING_MAP.listPrice);
        const price = {
          lineId: listPriceStepId,
          stepId: listPriceStepId,
          value: this.form.controls.selectedArticle.value.listPrice
        }

        return this.pricingService.updatePricing(offer, positionId, price, false);
      }),
      concatMap(() => {
        const priceStepId = (isDealer ? CUSTOM_PRICING_MAP.basePrice : FREE_PRICING_MAP.listPrice);
        const price = {
          lineId: priceStepId,
          stepId: priceStepId,
          value: (isDealer ? this.form.controls.selectedArticle.value.purchasePrice : this.form.controls.selectedArticle.value.listPrice)
        }

        return this.pricingService.updatePricing(offer, positionId, price, true);
      }),
      concatMap(() => this.offerPositionService.getArticleProductPosition(offer, positionId)),
      map((productPosition: OfferProductPosition) => {
        return this.storeService.setOfferUpdate({ productPositions: [productPosition] });
      })
    );
  }

  onClose(): void {
    const offer = this.addArticleToOfferComponent.offer;
    const positionId = this.addArticleToOfferComponent.position.id;

    this.offerPositionService.deletePositions(offer, [positionId])
      .subscribe(() => {
        this.storeService.resetCustomPosition();
      });
  }
}
